import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const LabelWithIconWrapper = styled.div<{ withBorder: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.space_size};
  padding: ${(props) => props.withBorder && `${theme.space_size}`};
  border: ${(props) =>
    props.withBorder ? `1px solid ${theme.colours.Platinum}` : 0};
  border-radius: ${(props) => (props.withBorder ? '100px' : 0)};
  height: 100%;
  span {
    font-size: 14px;
    color: ${theme.colours.DavysGrey};
    display: flex;
    font-family: ${theme.fonts.Medium};
    justify-content: flex-start;
    align-items: center;
  }
`;
